module.exports = __webpack_public_path__ + "assets/img/spritesheet-icons.994f3850.png";